import { render, staticRenderFns } from "./daHuoListV4.vue?vue&type=template&id=33442fd3&scoped=true&"
import script from "./daHuoListV4.vue?vue&type=script&lang=js&"
export * from "./daHuoListV4.vue?vue&type=script&lang=js&"
import style0 from "./daHuoListV4.vue?vue&type=style&index=0&id=33442fd3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33442fd3",
  null
  
)

export default component.exports